import Shop from 'containers/shop'

export default Shop
